import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { match } from 'react-router-dom';

// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas, FormPickerDatas } from '../../../local-types';
// Modules
import { Rider, RiderById, TParams } from '../../../redux/reducers/api-types';
import { ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import {
    actions as riderActions,
    selectors as riderSelectors,
    types as riderTypes,
} from '../../../redux/reducers/riders';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';
import FormUtils from '../../../utils/forms';

//TODO: DELETE FILE
interface RiderEditProps extends WithTranslation {
    match: match<TParams>;
    riders: RiderById;
    getOrEditRiderError: ErrorPayload;
    getRider: (id: string) => void;
    editRider: (id: string, payload: any) => void;
    isEditingUser: boolean;
}

interface RiderEditState {
    formData: any;
    old_email: string;
}

class RiderEditPage extends React.Component<RiderEditProps, RiderEditState> {
    state = {
        formData: {} as Rider,
        old_email: '',
    };

    generateLangOptions = (): FormPickerDatas[] => {
        const { t } = this.props;
        return FormUtils.generateLangOptions(t);
    };

    componentDidMount() {
        const id = this.props.match.params.id;
        const rider = this.props.riders[id];
        if (!rider) {
            this.props.getRider(id);
        }
    }

    static getDerivedStateFromProps(props: RiderEditProps, state: RiderEditState) {
        const id = props.match.params.id;
        const payload: Rider = props.riders[id];
        if (payload) {
            return { formData: payload, old_email: payload?.email };
        }
        return null;
    }

    generateInputs = (): FormDatas[] => {
        const { t } = this.props;

        const inputs: FormDatas[] = [
            {
                title: t('common:form.general_infos'),
                sectionStyle: { flex: 1 },
                datas: [
                    {
                        id: 'lastname',
                        label: t('common:form.lastname'),
                        required: true,
                    },
                    {
                        id: 'firstname',
                        label: t('common:form.firstname'),
                        required: true,
                    },
                    {
                        id: 'email',
                        label: t('common:form.email'),
                        type: 'email',
                        required: true,
                        regex: 'default',
                    },
                    {
                        id: 'phone',
                        label: t('common:form.phone_number'),
                        type: 'tel',
                        required: true,
                        regex: 'default',
                    },
                    {
                        id: 'language',
                        label: t('common:form.lang'),
                        options: this.generateLangOptions(),
                        noEmpty: true,
                    },
                    // {
                    //     id: 'additional_info',
                    //     label: t('common:form.additional_infos'),
                    // },
                ],
            },
        ];
        return inputs;
    };

    handleSubmit = (formData: any, event): void => {
        const { editRider, match } = this.props;
        const id = match.params.id;

        const payload = {
            firstname: formData.firstname,
            lastname: formData.lastname,
            emails: [
                {
                    old_email: this.state.old_email,
                    new_email: formData.email,
                },
            ],
            language: formData.language,
            phone: {
                number: formData.phone,
                country: 'fr', // TODO: mettre une lib pour numéro
            },
        };

        this.setState({
            formData: formData,
            old_email: formData.email,
        });

        editRider(id, payload);
    };

    render() {
        const { match, getOrEditRiderError, isEditingUser } = this.props;
        const id = match.params.id;
        const formPayload = this.state.formData;

        return (
            <App needRights={{ name: AccountRight.RIDER_PROFILE, mode: RightRank.W }} noFav>
                <ErrorMessage payload={getOrEditRiderError} />
                {formPayload && formPayload.id && (
                    <>
                        <EnhancedForm
                            payload={formPayload}
                            inputs={this.generateInputs()}
                            backRoute={`${paths.riders}/${id}`}
                            onSubmit={this.handleSubmit}
                            loader={isEditingUser}
                        />
                    </>
                )}
            </App>
        );
    }
}

const RiderEditPageWithTranslation = withTranslation(['rider', 'common'])(RiderEditPage);

const mapStateToProps = (state) => ({
    riders: riderSelectors.users(state),
    getOrEditRiderError: errorSelectors.getOrEditRiderError(state),
    isEditingUser: pendingSelectors.isPending(state, riderTypes.EDIT_USER),
});

const mapDispatchToProps = {
    getRider: riderActions.getUser,
    editRider: riderActions.editUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(RiderEditPageWithTranslation);
